import { useContext, useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../src/App";
import {
  Box,
  Chip,
  Typography,
  CircularProgress,
  Button,
  Alert,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useNavigate } from "react-router-dom";

import "../App.css";
import AddUserModal from "../components/Modals/AddUserModal";
import { formatDate } from "../helper";
import PageTitles from "../components/Layout/PageTitles";

const UsersPage = () => {
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState();
  const [buttonHidden, setButton] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/users`).then((res) => {
      const users = res.data.users;
      users.map((user) => {
        user.endDate = formatDate(user.endDate);
      });
      setUserData(users);
      setIsLoading(false);
    });
  }, [refresh]);

  const columns = [
    {
      field: "username",
      headerName: "Username",
      renderCell: ({ row: { username } }) => {
        return (
          <Box
            sx={{ p: "1px 7px 1px 7px" }}
            borderRadius="15%"
            className="userNameBox"
          >
            <Typography className="theUserNames">{username}</Typography>
          </Box>
        );
      },
    },
    { field: "name", headerName: "Name", minWidth: 150, flex: 1 },
    { field: "company", headerName: "Company", minWidth: 150, flex: 1 },
    { field: "email", headerName: "E-mail", minWidth: 200, flex: 2 },
    {
      field: "accountType",
      headerName: "Account type",
      align: "center",
      headerAlign: "center",
      renderCell: ({ row: { accountType } }) => {
        return (
          <>
            {accountType === "plus" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#6a1b9a",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "view" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#2196f3",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "free" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#ff9800",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "admin" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#009688",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "standard" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#01579b",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
          </>
        );
      },
    },
    {
      field: "mfaKey",
      headerName: "MFA?",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      renderCell: ({ row: { mfaKey } }) => {
        return (
          <Box display="flex" justifyContent="center">
            <CancelRoundedIcon fontSize="small" sx={{ color: "#f44336" }} />
          </Box>
        );
      },
    },

    {
      field: "state",
      headerName: "State",
      align: "center",
      headerAlign: "center",
      flex: 0.9,
      renderCell: ({ row: { state } }) => {
        return (
          <>
            {state === "Active" && (
              <Chip
                label={state}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#4caf50",
                  ml: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {state !== "Active" && (
              <Chip
                label={state}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#f44336",
                  ml: "5px",
                  fontSize: "1em",
                }}
              />
            )}
          </>
        );
      },
    },
    { field: "endDate", headerName: "Expiry" },
  ];

  const handleEvent = (
    params, // GridRowParams
    event, // MuiEvent<React.MouseEvent<HTMLElement>>
    details // GridCallbackDetails
  ) => {
    setSelectedUser(params.row);
    setButton(true);
  };

  // if (isLoading)
  //   return (
  //     <Box display="flex" justifyContent="center" sx={{ mt: "30vh" }}>
  //       <CircularProgress />
  //     </Box>
  //   );
  // else
  return (
    <>
      <PageTitles title={"View Users"} />
      <Box m="10px" sx={{ backgroundColor: "#212121", p: "20px" }}>
        {alert ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="success"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        {alert === "error" ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="error"
          >
            There was an error when adding user!
          </Alert>
        ) : (
          <></>
        )}

        <Box>
          <DataGrid
            loading={isLoading}
            autoHeight
            autoWidth
            getRowId={(row) => row.username}
            rows={userData}
            columns={columns}
            onRowClick={handleEvent}
            initialState={{
              filter: {
                filterModel: {
                  items: [
                    {
                      columnField: "state",
                      operatorValue: "equals",
                      value: "Active",
                    },
                  ],
                },
              },
            }}
          />
        </Box>

        {/* Opens modal to add new user */}
        <Box sx={{ display: "flex", justifyContent: "right", pt: "px" }}>
          <AddUserModal
            refresh={refresh}
            setRefresh={setRefresh}
            setAlert={setAlert}
            setAlertContent={setAlertContent}
          />

          {buttonHidden && (
            <Button
              variant="contained"
              sx={{ ml: "5px", mt: "10px" }}
              onClick={() => navigate(`/users/${selectedUser.username}`)}
            >
              {" "}
              View /Edit user: {selectedUser.name}
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UsersPage;
